import {Component, OnInit} from '@angular/core';
import {StoreService} from 'src/app/_services/store.service';
import { Store } from 'src/app/_models/store';
import {ActivatedRoute, Router} from '@angular/router';
import { Location } from '@angular/common';
import { buildStatementModel } from '../statement-math';

@Component({
  selector: 'app-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss']
})
export class ReportDialogComponent implements OnInit {

  reportUrl
  storeId: any;
  month: any;
  year: any;
  data: any;
  m: any = {}; // mini report data for 9 sections
  varianceCheck: any = {};
  dataAvailable: boolean = false;
  /** Daily third-party app columns, shown once the month has third-party app orders. */
  showThirdPartyColumns = false;
  isLoading: boolean = true;
  startDate: any;
  endDate: any;
  store: any;
  constructor(
    private route: ActivatedRoute,
    private storeService: StoreService,
    private location: Location,
    private router: Router
  ) { }

  ngOnInit() {
    this.storeId = this.route.snapshot.paramMap.get('store_id');
    this.startDate = this.route.snapshot.paramMap.get('month');
    this.endDate = this.route.snapshot.paramMap.get('year');
    this.storeService.current.subscribe((store: any) => {
      // Hydrate into a real Store instance so template calls like
      // store.hasModule('POS') work (service emits a plain object).
      this.store = Object.assign(new Store(), store);
    });
    this.monthlyStatement();
  }

  monthlyStatement() {
    this.storeService.getStoreDetailedReportsHTML(this.storeId, this.startDate, this.endDate)
    .subscribe((statement: any) => {
      const model = buildStatementModel(statement);
      this.data = statement;
      this.m = model.m;
      // Third-party apps (DoorDash, Uber Eats …) are their own bucket; statement-math keeps them out of Kiosk.
      this.m.third = model.m.thirdParty || {};
      this.m.hasThirdParty = (parseInt(this.m.third.total_orders, 10) || 0) > 0;
      this.showThirdPartyColumns = this.m.hasThirdParty
        || (parseInt(statement?.summary?.total_order_count_third_party, 10) || 0) > 0;
      // Same variance figure as reporting-home and the one-page statement's footer.
      this.varianceCheck = model.varianceCheck;
      this.dataAvailable = true;
      this.isLoading = false;
    });
  }

  goBack(): void {
    this.location.back();
  }

  openSummary(): void {
    this.router.navigate([`/monthly-summary/${this.storeId}/${this.startDate}/${this.endDate}`]);
  }

}
